<script setup lang="ts">
const props = defineProps({
  iso: {
    type: String,
    default: () => '',
  },
  title: {
    type: String,
    default: () => '',
  },
});
</script>

<template>
  <div
    class="flag"
    :class="[`flag-icon-${props.iso.toLowerCase()}`]"
    :title="props.title"
  />
</template>

<style lang="scss">
.flag {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  position: relative;
  display: inline-block;
  width: 12px;
  aspect-ratio: 4 / 3;
}
</style>
